import type { ReactNode } from "react";
import { useT } from "@/contexts/I18nContext";

/**
 * The frame every section page sits in.
 *
 * A heading and a slot. Sections whose bodies arrive in later phases render the
 * heading alone rather than a placeholder — an invented "coming soon" panel is
 * a promise to a paying institution that nobody made.
 */
export function SectionShell({
  titleKey,
  titleParams,
  actions,
  children,
}: {
  titleKey: string;
  titleParams?: Record<string, unknown>;
  actions?: ReactNode;
  children?: ReactNode;
}) {
  const t = useT();
  return (
    <div>
      <div className="flex items-start justify-between gap-4">
        <h1 className="page-title">{t(titleKey, titleParams)}</h1>
        {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
      </div>
      <div className="mt-6">{children}</div>
    </div>
  );
}
